import request from '../httpClient';

// tslint:disable-next-line: no-any
export const getReservations = (params: any) => {
  const endpoint =
    params.q || params.teamId ? '/reservations/search' : '/reservations';
  const {limit = 20, offset = 0, ...restParams} = params;

  return request.get(endpoint, {
    _limit: limit,
    _offset: offset,
    ...restParams
  });
};



// WEBPACK FOOTER //
// ./src/services/api/reservationsApi.ts